import { OneModal } from '@yy/one-ui'

/**
 * 可await的命令式弹窗，点击ok返回true，点击cancel返回false
 * @param props
 * @returns
 */
export const awaitConfirm = ({
  throwError,
  ...props
}: Parameters<typeof OneModal.confirm>[0] & {
  throwError?: boolean
}): Promise<boolean> =>
  new Promise((res, reject) => {
    OneModal.confirm({
      ...props,
      onOk: async () => {
        const temp = await props.onOk?.()
        res(true)
        return temp
      },
      onCancel: () => {
        const temp = props.onCancel?.()
        if (throwError) {
          reject(false)
        } else {
          res(false)
        }
        return temp
      },
    })
  })
